import { useNavigationUtils } from "@/utils/navigationHooks";
import { usePrivy } from "@privy-io/react-auth";
import { useEffect } from "react";
import { getCookie } from "typescript-cookie";
import { useTransactionSnackbar } from "@/hooks/useTransactionSnackbar";
import { useAuth } from "@/provider/AuthProvider";
interface AutoLogoutProps {
  children: React.ReactNode;
}


export default function AutoLogout({ children }: AutoLogoutProps) {
  const { ready, authenticated, getAccessToken } = usePrivy();
  const { handleLogout } = useNavigationUtils();
  const { showTransactionSnackbar } = useTransactionSnackbar();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (ready && authenticated && isAuthenticated) {
      const checkTokens = () => {
        const expireAccessToken = getCookie("expireAccessToken"); // 2025-04-29T10:58:49.289Z
        const currentDate = new Date();
        const expireDateUTC = new Date(expireAccessToken || "");
        const expireDate = new Date(expireDateUTC.getTime());
        const isExpired = expireDate <= currentDate;
        if (isExpired) {
          handleLogout()
          showTransactionSnackbar({
            status: "error",
            title: "Session Expired",
            message: "Your session has expired. Please log in again.",
          });
        }
      };

      // Check immediately
      checkTokens();

      // Set up interval to check periodically
      const intervalId = setInterval(checkTokens, 5 * 60 * 1000);

      // Clean up interval on unmount
      return () => clearInterval(intervalId);
    }
  }, [ready, authenticated, getAccessToken, handleLogout, isAuthenticated]);

  return <>{children}</>;
}
